class DashboardCheckBoxOutput {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {NodeListOf<Element>}
         */
        this.checkOutput = document.querySelectorAll('[data-check-output]');
        /**
         * @type {NodeListOf<Element>}
         */
        this.targets = document.querySelectorAll('[data-check-input] input');
        /**
         * Init
         */
        this._init()
    }

    /**
     * Init
     * @private
     */
    _init() {
        for (let i = 0; i < this.checkOutput.length; i++) {
            const BOUND_LIST = document.querySelector('[data-check-input="' + this.checkOutput[i].id + '"]');

            if (DashboardCheckBoxOutput.allInputInListIsChecked(BOUND_LIST)) {
                this.checkOutput[i].checked = true;
                if (this.checkOutput[i].hasAttribute('data-tool')) {
                    const LINK_TOOL = DashboardCheckBoxOutput.getLinkToTool(this.checkOutput[i]);
                   LINK_TOOL.classList.add('show');
                }
            }

            this.checkOutput[i].addEventListener('click', (e) => DashboardCheckBoxOutput._toggleAllCheckBox(e));
        }
        for (let i = 0; i < this.targets.length; i++) {
            this.targets[i].addEventListener('click', (e) => DashboardCheckBoxOutput._clickTarget(e));
        }

        const TOOL_LINKS = document.querySelectorAll('[data-tool-checked]');
        for (let i = 0; i < TOOL_LINKS.length; i++) {
            const TOOL_LINK = TOOL_LINKS[i];

            if (TOOL_LINK.getAttribute('data-tool-checked') === '1') {
                DashboardCheckBoxOutput.getLinkToTool(TOOL_LINK).classList.add('show');
            }
        }
    }

    /**
     * Check if all child element in list is checked
     * @param list
     * @return {boolean}
     */
    static allInputInListIsChecked(list) {
        const SIBLING_INPUTS         = list.querySelectorAll('input');
        const SIBLING_INPUTS_CHECKED = list.querySelectorAll('input:checked');

        return SIBLING_INPUTS.length === SIBLING_INPUTS_CHECKED.length;
    }

    /**
     * Click target
     * @param e
     * @private
     */
    static _clickTarget(e) {
        const INPUT_CHECKBOX  = e.target;
        const BOUND_CHECK_ALL = document.querySelector('#check_all_' + INPUT_CHECKBOX.id.split('_')[1]);
        const LINK_TOOL = DashboardCheckBoxOutput.getLinkToTool(BOUND_CHECK_ALL);

        // If all child is checked check parent
        if (DashboardCheckBoxOutput.allInputInListIsChecked(INPUT_CHECKBOX.closest('ul'))) {
            BOUND_CHECK_ALL.checked = true;
            if (BOUND_CHECK_ALL.hasAttribute('data-tool')) {
                LINK_TOOL.classList.add('show');
            }
        }

        // Some uncheck target
        if (!INPUT_CHECKBOX.checked) {
            BOUND_CHECK_ALL.checked = false;
            if (BOUND_CHECK_ALL.hasAttribute('data-tool')) {
                LINK_TOOL.classList.remove('show');
            }
        }
    }

    static getLinkToTool(input) {
        return input.parentElement.parentElement.querySelector('.btn-toolbox, .link-toolbox');
    }

    /**
     * Toggle checked
     * @private
     */
    static _toggleAllCheckBox(e) {
        const CHECK_OUTPUT = e.target;
        const TARGETS      = document.querySelectorAll('[data-check-input="' + e.target.getAttribute('data-check-output') + '"] input');

        // check/nocheck
        for (let i = 0; i < TARGETS.length; i++) {
            TARGETS[i].checked = !!CHECK_OUTPUT.checked;

            // Toggle link to the took
            if (TARGETS[i].hasAttribute('data-tool')) {
                const LINK_TOOL = DashboardCheckBoxOutput.getLinkToTool(TARGETS[i]);
                if (TARGETS[i].checked) {
                    LINK_TOOL.classList.add('show');
                } else {
                    LINK_TOOL.classList.remove('show');
                }
            }
        }
    }

}